var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: {
        page: "/dashboard",
        pageTitle: "Finance Entry",
        backLink: "/dashboard/reports",
      },
      on: {
        fabAction: function ($event) {
          _vm.newFinanceEntry = true
        },
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "soli-subtitle" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `${_vm.$page.props.auth.user.selected_location.name}`
                                    ) + "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                { staticStyle: { "white-space": "normal" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `Monthly finance tracking from Quickbooks`
                                    ) + "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-list-item-subtitle", {
                                staticClass: "font-bold",
                                staticStyle: { "white-space": "normal" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.studioFinances,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                    },
                    on: {
                      "click:row": function ($event) {
                        return _vm.editEntry($event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.date`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.globalMomentMonthYear(item.date)
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.revenue`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.formatter(item.revenue)) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.cost_of_goods`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.formatter(item.cost_of_goods)
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.expenses`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.formatter(item.expenses)) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.marketing`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.formatter(item.marketing)) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.liabilities`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.formatter(item.liabilities)) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.newFinanceEntry
        ? _c("SoliForm", {
            ref: "form",
            attrs: {
              title: `${_vm.editing ? "Editing" : "New"} Finance Entry`,
              icon: "save",
              persistent: "",
              loadingProp: _vm.form.processing,
            },
            on: {
              submit: function ($event) {
                return _vm.submitFinances()
              },
              reset: function ($event) {
                return _vm.resetFinances()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("SoliDate", {
                        attrs: {
                          type: "month",
                          rules: _vm.rules.input,
                          error: _vm.errors.date,
                          max: _vm.dateMax(),
                          events: _vm.studioFinances.length
                            ? _vm.studioFinances.map((e) =>
                                _vm.globalMomentMonthYear(e.date)
                              )
                            : _vm.globalMomentMonthYear(new Date()),
                        },
                        model: {
                          value: _vm.form.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "date", $$v)
                          },
                          expression: "form.date",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-currency-field", {
                        staticClass: "soli-round",
                        attrs: {
                          label: "Revenue",
                          rules: _vm.rules.input,
                          outlined: "",
                          dense: "",
                          "error-messages": _vm.errors.revenue,
                        },
                        model: {
                          value: _vm.form.revenue,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "revenue", $$v)
                          },
                          expression: "form.revenue",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-currency-field", {
                        staticClass: "soli-round",
                        attrs: {
                          label: "Cost of Goods",
                          rules: _vm.rules.input,
                          outlined: "",
                          dense: "",
                          "error-messages": _vm.errors.cost_of_goods,
                        },
                        model: {
                          value: _vm.form.cost_of_goods,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cost_of_goods", $$v)
                          },
                          expression: "form.cost_of_goods",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-currency-field", {
                        staticClass: "soli-round",
                        attrs: {
                          label: "Expenses",
                          rules: _vm.rules.input,
                          outlined: "",
                          dense: "",
                          "error-messages": _vm.errors.expenses,
                        },
                        model: {
                          value: _vm.form.expenses,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expenses", $$v)
                          },
                          expression: "form.expenses",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-currency-field", {
                        staticClass: "soli-round",
                        attrs: {
                          label: "Marketing",
                          rules: _vm.rules.input,
                          outlined: "",
                          dense: "",
                          "error-messages": _vm.errors.marketing,
                        },
                        model: {
                          value: _vm.form.marketing,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "marketing", $$v)
                          },
                          expression: "form.marketing",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-currency-field", {
                        staticClass: "soli-round",
                        attrs: {
                          label: "Liabilities",
                          rules: _vm.rules.input,
                          outlined: "",
                          dense: "",
                          "error-messages": _vm.errors.liabilities,
                        },
                        model: {
                          value: _vm.form.liabilities,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "liabilities", $$v)
                          },
                          expression: "form.liabilities",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1442220338
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMessage
        ? _c("SoliSnack", {
            attrs: { text: _vm.$page.props.successMessage },
            on: {
              hide: function ($event) {
                _vm.showMessage = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }